import { useCallback, useEffect, useState } from "react";
import { MakeApiCall } from "../apis";

/**
 * Shared Setup Guide progress fetch for page + header chip.
 * @param {string|undefined} token
 * @param {{ enabled?: boolean }} [options]
 */
export default function useSetupGuide(token, options = {}) {
  const { enabled = true } = options;
  const [loading, setLoading] = useState(Boolean(enabled && token));
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!enabled || !token) {
      setLoading(false);
      setData(null);
      return null;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await MakeApiCall(
        "setup-guide",
        "get",
        null,
        true,
        {},
        token
      );
      if (response?.status) {
        setData(response.data || null);
        setLoading(false);
        return response.data;
      }
      setData(null);
      setError(response?.message || "Failed to load setup guide");
      setLoading(false);
      return null;
    } catch (err) {
      setData(null);
      setError(err?.message || "Failed to load setup guide");
      setLoading(false);
      return null;
    }
  }, [enabled, token]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!enabled || !token) {
        setLoading(false);
        setData(null);
        return;
      }
      setLoading(true);
      const response = await MakeApiCall(
        "setup-guide",
        "get",
        null,
        true,
        {},
        token
      );
      if (cancelled) return;
      if (response?.status) {
        setData(response.data || null);
        setError(null);
      } else {
        setData(null);
        setError(response?.message || "Failed to load setup guide");
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [enabled, token]);

  return {
    loading,
    data,
    error,
    remainingSteps: data?.remaining_steps ?? null,
    steps: data?.steps || null,
    refresh,
  };
}
